import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { DOCS, CONTACT } from '../legal/docs';
export function Legal() {
  const {
    slug
  } = useParams();
  const doc = slug ? DOCS[slug] : undefined;
  if (!doc) {
    return <div className="min-h-screen bg-background text-white flex flex-col" data-id="element-370" data-mp="nrs8f0r4mjth">
        <Navbar data-id="element-371" data-mp="a16qbe9hydwn" />
        <div className="flex-1 flex flex-col items-center justify-center gap-6 px-6 text-center" data-id="element-372" data-mp="a0nd2auskdoy">
          <h1 className="font-display text-3xl" data-id="element-373" data-mp="etghsyq9fm11">Esta pagina no existe</h1>
          <Link to="/" className="text-accent hover:underline" data-id="element-374" data-mp="40w3x5l66s7">
            Volver al inicio
          </Link>
        </div>
        <Footer data-id="element-375" data-mp="53n8k4dlbizy" />
      </div>;
  }
  return <div className="min-h-screen bg-background text-white" data-id="element-376" data-mp="50948qld8zpv">
      <Navbar data-id="element-377" data-mp="3n9jjmnuoyghg" />

      <article className="max-w-[720px] mx-auto px-5 sm:px-6 pt-32 md:pt-40 pb-24" data-id="element-378" data-mp="3n907jnrq2mbc">
        <div className="flex items-center gap-2 text-[13px] text-white/40 mb-8" data-id="element-379" data-mp="3s6s1enbxgii6">
          <Link to="/" className="hover:text-white/70 transition-colors" data-id="element-380" data-mp="27k3hh8gb2e1p">
            Blinkblis
          </Link>
          <span data-id="element-381" data-mp="23izzogep67xu">/</span>
          <span className="text-accent" data-id="element-382" data-mp="23lm5aai12ddf">Legal</span>
        </div>

        <h1 className="font-display text-[34px] sm:text-5xl font-semibold tracking-[-0.03em] leading-[1.1] mb-4" data-id="element-383" data-mp="2hhzp3qa1aqv2">
          {doc.title}
        </h1>
        <p className="text-[14px] text-white/40 mb-12 pb-8 border-b border-white/10" data-id="element-384" data-mp="1oun1rdw1uf0p">
          Ultima actualizacion: {doc.updated}
        </p>

        <div className="space-y-6" data-id="element-385" data-mp="1jwllt1tx6vtg">
          {doc.blocks.map((block, i) => {
          if ('h' in block) {
            return <h2 key={i} className="font-display text-[22px] sm:text-2xl font-semibold tracking-[-0.02em] text-white pt-6" data-id="element-386" data-mp="1ymj8teg45fh2">
                  {block.h}
                </h2>;
          }
          if ('ul' in block) {
            return <ul key={i} className="space-y-3" data-id="element-387" data-mp="317bqgbzcz877">
                  {block.ul.map(item => <li key={item} className="flex gap-3 text-[16px] leading-[1.75] text-white/60 font-light" data-id="element-388" data-mp="366ewnzr2rkgr">
                      <span className="text-accent shrink-0 mt-0.5" data-id="element-389" data-mp="3az826pudawtw">—</span>
                      <span data-id="element-390" data-mp="3exfb4yilatuj">{item}</span>
                    </li>)}
                </ul>;
          }
          return <p key={i} className="text-[16px] leading-[1.8] text-white/60 font-light" data-id="element-391" data-mp="2n79boymckuw6" data-mpi={i}>
                {block.p}
              </p>;
        })}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10" data-id="element-392" data-mp="2w8hariwotzrb">
          <h2 className="font-display text-xl font-semibold mb-3" data-id="element-393" data-mp="2w5uumuvqebxh">Contacto</h2>
          <p className="text-[16px] text-white/60 font-light leading-relaxed" data-id="element-394" data-mp="6ingzkaq5rai">
            Para cualquier consulta sobre este documento, escribenos a{' '}
            <a href={`mailto:${CONTACT}`} className="text-accent hover:underline" data-id="element-395" data-mp="lm6peymzzm5e">
              {CONTACT}
            </a>
            .
          </p>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-[14px]" data-id="element-396" data-mp="bvlpn7vl8bkw">
            {Object.entries(DOCS).filter(([key]) => key !== slug).map(([key, d]) => <Link key={key} to={`/${key}`} className="text-white/40 hover:text-white transition-colors" data-id="element-397" data-mp="2vyqksqbzhv0">
                  {d.title}
                </Link>)}
          </div>
        </div>
      </article>

      <Footer data-id="element-398" data-mp="3l1br4gk42t8i" />
    </div>;
}